import { render, staticRenderFns } from "./PhotoPreview.vue?vue&type=template&id=1af28647&scoped=true"
import script from "./PhotoPreview.vue?vue&type=script&lang=js"
export * from "./PhotoPreview.vue?vue&type=script&lang=js"
import style0 from "./PhotoPreview.vue?vue&type=style&index=0&id=1af28647&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af28647",
  null
  
)

export default component.exports